import React from 'react';
import { CreateEmployeeForm } from '../../modules/employee';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';

const EmployeeRegisterView = () => {
    return (
        <EditScreenLayout path={routePaths.employee}>
            <CreateEmployeeForm />
        </EditScreenLayout>
    );
};


export default EmployeeRegisterView;
